import { lastValueFrom } from 'rxjs';
import { IActionCenterUnlinker } from '../../interfaces';
import { FilesService } from '@app/pages/cmms/services/files.service';
import { IClassification } from '@app/pages/cmms/interfaces/classification.interfaces';

export class FileClassificationSuggestionsUnlinker
	implements IActionCenterUnlinker<IClassification>
{
	private readonly filesService: FilesService;
	constructor(deps: { filesService: FilesService }) {
		this.filesService = deps.filesService;
	}
	unlink(selectedPks: string[], targets: IClassification[]): Promise<any> {
		const payload = {
			mappings: [
				{
					fileId: selectedPks[0],
					classifications: targets.map(classification => classification.pk),
				},
			],
		};
		const obs = this.filesService.removeClassificationSuggestion(payload);
		return lastValueFrom(obs);
	}
}
